import { useEffect, useState } from "react"
import formatNumber from "@/lib/Common"
import dayjs from "@/lib/dayjs";
import { BidBadge } from "./BidBadge"
import { TbClockHour3 } from "react-icons/tb"

export function BidBadgeWithCountdown({
    targetTime,
    bid,
    gunbroker_item_id,
    ...props
}) {
    const [currentTime, setCurrentTime] = useState(dayjs.utc())
    const [timeLeft, setTimeLeft] = useState(
        dayjs.duration(targetTime.diff(dayjs.utc()))
    )
    const [variant, setVariant] = useState()
    const [displayTime, setDisplayTime] = useState("")

    useEffect(() => {
        const interval = setInterval(() => {
            const now = dayjs.utc()
            setCurrentTime(now)
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        const newTimeBetween = dayjs.duration(targetTime.diff(currentTime))
        setTimeLeft(newTimeBetween)

        let badgeVariant = "default"
        if (newTimeBetween.asHours() < 24) {
            if (newTimeBetween.asHours() <= 0) {
                badgeVariant = "lastcall"
            } else if (newTimeBetween.asHours() < 2) {
                badgeVariant = "danger"
            } else {
                badgeVariant = "warning"
            }
        }

        setVariant(badgeVariant)
    }, [currentTime, targetTime])

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768)
        }

        handleResize()
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(() => {
        let time

        if (timeLeft.asSeconds() >= 0) {
            if (timeLeft.days() > 0) {
                time = `${timeLeft.days()} day${timeLeft.days() > 1 ? "s" : ""}`
            } else if (isMobile) {
                // Mobile: show only hours or minutes
                if (timeLeft.hours() > 0) {
                    time = `${parseInt(formatTimePart(timeLeft.hours()))}h`
                } else if (timeLeft.minutes() > 0) {
                    time = `${parseInt(formatTimePart(timeLeft.minutes()))}m`
                } else {
                    time = `${parseInt(formatTimePart(timeLeft.seconds()))}s`
                }
            } else {
                // Desktop: show full HH:MM:SS
                time = `${formatTimePart(timeLeft.hours())}:${formatTimePart(
                    timeLeft.minutes()
                )}:${formatTimePart(timeLeft.seconds())}`
            }
        } else {
            time = "Last Call"
        }

        setDisplayTime(time)
    }, [timeLeft, gunbroker_item_id, isMobile])

    const formatTimePart = (value) => {
        return value.toString().padStart(2, "0")
    }

    return (
        variant && (
            <BidBadge variant={variant} {...props}>
                <span className="flex items-center text-xs whitespace-nowrap">
                    <TbClockHour3 className="inline w-[16px] h-[16px] me-1 text-white" />
                    <span className="font-semibold text-xs tracking-[0.08px]">
                        {displayTime}
                    </span>
                </span>
                <span className="pl-1 text-xs font-normal whitespace-nowrap">
                    Bid{" "}
                    <span className="font-semibold tracking-[0.08px]">
                        ${formatNumber(bid)}
                    </span>
                </span>
            </BidBadge>
        )
    )
}
